<ng-template #content>
  <span
    class="flex w-10 h-10 rounded-full bg-white group-hover:bg-primary justify-center items-center p-1">
    <mat-icon
      aria-hidden="false"
      aria-label="Icon"
      class="!block !h-16 !w-auto !max-w-16 !-rotate-90"
      svgIcon="right_arrow"/>
  </span>
</ng-template>

<button (click)="scrollToFragment()"
        (keydown)="scrollToFragment()"
        [class.is-visible]="((tariffStore.tariff$() && tariffStore.size$()) && active())"
        class="p-1 bg-white app-scroll-to-table-button rounded-full"
        tabindex="-1">
  <div
    class="button-with-arrow group bg-primary hover:bg-white group-hover:bg-white flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot justify-center items-center gap-4 md:gap-6 hover:border hover:border-solid text-white p-1 ">
    <ng-container
      *ngTemplateOutlet="content">
    </ng-container>
  </div>
</button>
